import { createPrismic } from "@prismicio/vue";
import { createClient } from "@prismicio/client";

import { linkResolver } from "./linkResolver";
import PrismicImageBlock from "./PrismicImageBlock.vue";

const client = createClient(process.env.VUE_APP_PRISMIC_REPO_NAME);

const prismic = createPrismic({
  client,
  linkResolver,
  components: {
    image: PrismicImageBlock,
  },
});

export default prismic;
